var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAirplaneTakeoff = function SvgIconAirplaneTakeoff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.78 4.94a4 4 0 0 1 5.125.914v.001l1.745 2.138a1 1 0 0 1-.273 1.496L9.185 17.74a4 4 0 0 1-4.75-.537L.902 13.894v-.001a1.75 1.75 0 0 1 .503-2.887l1.576-.675a1 1 0 0 1 .788 0l2.167.929.99-.567-1.848-1.662a1.752 1.752 0 0 1 .48-2.91l1.546-.665a1 1 0 0 1 .712-.03l5.194 1.731zm2.38 1.479a2 2 0 0 0-1.365.246L13.63 9.112a1 1 0 0 1-.822.087L7.545 7.444l-.84.361 2.588 2.326a1 1 0 0 1-.172 1.612l-2.625 1.5a1 1 0 0 1-.89.051l-2.231-.956-.83.355 3.257 3.049a2 2 0 0 0 2.375.269L21.36 8.349l-1.002-1.228a2 2 0 0 0-1.197-.702M2.266 12.43l.002.001z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 20.25a1 1 0 0 1 1-1h13.5a1 1 0 1 1 0 2H2.25a1 1 0 0 1-1-1"
  }))));
};
export default SvgIconAirplaneTakeoff;